var _excluded = ["id", "IconButtonProps", "options", "onClose"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { Day as DayIcon, Night as NightIcon, DayNight as SystemIcon } from '@mineral/icons';
import { useMultiTheme } from '../MultiThemeProvider';
import { IconButton, ListItemIcon, ListItemText, MenuItem, Menu } from '../index';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// Exported to allow user to compose custom options with these defaults
export var themeMenuOptions = [{
  icon: /*#__PURE__*/_jsx(SystemIcon, {}),
  text: 'System',
  theme: 'system'
}, {
  icon: /*#__PURE__*/_jsx(DayIcon, {}),
  text: 'Light',
  theme: 'light'
}, {
  icon: /*#__PURE__*/_jsx(NightIcon, {}),
  text: 'Dark',
  theme: 'dark'
}];
export var ThemeMenu = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$id = _ref.id,
      id = _ref$id === void 0 ? 'theme-menu' : _ref$id,
      IconButtonProps = _ref.IconButtonProps,
      optionsProp = _ref.options,
      ignoreOnClose = _ref.onClose,
      restProps = _objectWithoutPropertiesLoose(_ref, _excluded);

  var options = optionsProp != null ? optionsProp : themeMenuOptions;

  var _useMultiTheme = useMultiTheme(),
      theme = _useMultiTheme.theme,
      setTheme = _useMultiTheme.setTheme;

  var selectedOption = options.find(function (option) {
    return option.theme === theme;
  }) || options[0];

  var _React$useState = React.useState(null),
      anchorEl = _React$useState[0],
      setAnchorEl = _React$useState[1];

  var open = Boolean(anchorEl);
  var menuId = id;
  var triggerId = menuId + "-trigger";

  var handleButtonClick = function handleButtonClick(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleMenuItemClick = function handleMenuItemClick(theme) {
    setAnchorEl(null);
    setTheme(theme);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
  };

  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(IconButton, _extends({
      id: triggerId,
      size: "large",
      color: "inherit",
      "aria-haspopup": "listbox",
      "aria-controls": open ? menuId : undefined,
      "aria-label": "theme menu",
      "aria-expanded": open || undefined,
      onClick: handleButtonClick
    }, IconButtonProps, {
      children: selectedOption.icon
    })), // Seemingly necessary to use open check here, rather than relying on open={open} prop, else the
    // menu does not unmount properly after selecting a theme.
    open && /*#__PURE__*/_jsx(Menu, _extends({
      id: menuId,
      anchorEl: anchorEl,
      open: open,
      onClose: handleClose,
      ref: ref,
      MenuListProps: {
        'aria-labelledby': triggerId,
        role: 'listbox'
      }
    }, restProps, {
      children: options.map(function (_ref2) {
        var icon = _ref2.icon,
            text = _ref2.text,
            theme = _ref2.theme;
        return /*#__PURE__*/_jsxs(MenuItem, {
          selected: theme === selectedOption.theme,
          onClick: function onClick() {
            return handleMenuItemClick(theme);
          },
          children: [/*#__PURE__*/_jsx(ListItemIcon, {
            children: icon
          }), /*#__PURE__*/_jsx(ListItemText, {
            children: text
          })]
        }, theme);
      })
    }))]
  });
});